import { addOpus } from '~/api'
import { CONFIG_NAV, CONTENT_TABS, type SUB_NAV } from '~/constants'

export const createWork = async (resolution: string, source?: SOURCE) => {
  const route = useRoute()

  if (source) {
    trackEvent(TRACK_EVENT.YOUYAN_PLATFORM_CREATE_NEW_CLICK, {
      source,
      dimension: !resolution
        ? CREATE_OPUS.DEFAULT
        : resolution === '1920x1080'
          ? CREATE_OPUS.HORIZONTAL
          : CREATE_OPUS.VERTICAL,
    })
  }
  // 创建作品
  if (resolution) {
    const res = await addOpus({
      resolution,
    })
    sendEditorInfo(`${CONFIG_NAV.CONTENT}-${CONTENT_TABS.STUDIO}`)
    trackEvent(TRACK_EVENT.启动编辑器, {
      source,
      page: route.name,
    })
    window.location.href = `/editor/${res?.data.id}/${res?.data.secret_id}`
  }
}

export const createWorkByCharacter = async <T extends keyof SUB_NAV>(
  characterId: number,
  navKey: T,
  subKey?: SUB_NAV[T]
) => {
  try {
    const route = useRoute()

    const res = await addOpus({
      character_id: characterId,
    })

    const jumpKey = subKey ? `${navKey}-${subKey}` : navKey

    sendEditorInfo(jumpKey)
    trackEvent(TRACK_EVENT.启动编辑器, {
      page: route.name,
    })
    window.location.href = `/editor/${res?.data.id}/${res?.data.secret_id}`
  } catch (e) {}
}
